import { render, staticRenderFns } from "./favorite-groups.vue?vue&type=template&id=85837622&scoped=true"
import script from "./favorite-groups.vue?vue&type=script&lang=js"
export * from "./favorite-groups.vue?vue&type=script&lang=js"
import style0 from "./favorite-groups.vue?vue&type=style&index=0&id=85837622&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85837622",
  null
  
)

export default component.exports